<template>
	<div></div>
</template>

<script>
	import {
		getItem,
		removeToken,
		removeItem,
		traceAuth
	} from '@/utils/auth'
	export default {
		data() {
			return {
				socket: null,
				timeoutObj: null,
				reconnectTimer: null,
				timeout: 30 * 1000,
				socketUrl: "",
				timeEnd: 0,
				isDestroyed: false,
				retryNotified: false
			}
		},
		props: ['nowTime'],
		mounted() {
			let that = this
			// that.socketUrl = 'ws://192.168.31.73:10100/imserver/' + getItem('userInfo').account + '_' + this.nowTime.toString() + '_' + getItem('userInfo').tenantInfoId
			that.socketUrl = config.socketUrl + getItem('userInfo').account + '_' + this.nowTime.toString() + '_' +
				getItem('userInfo').tenantInfoId
			that.initWebSocket(that.socketUrl)
		},
		methods: {
			initWebSocket(url) {
				if (this.isDestroyed) return
				this.timeEnd++;
				if (this.timeEnd > 3) {
					// 连续失败只提示一次，之后降速重试；网络恢复前不清登录态，避免大屏挂机被踢回登录页
					if (!this.retryNotified) {
						this.retryNotified = true
						traceAuth('信令连续重连失败' + this.timeEnd + '次，已降速至30秒重试（未登出）')
						this.$notify.warning({
							title: '信令连接不稳定，正在自动重试'
						})
					}
					this.scheduleReconnect(url, 30000)
					return
				}
				if (typeof WebSocket === 'undefined') {
					alert('您的浏览器不支持socket')
				} else {
					this.socket = new WebSocket(url)
					this.socket.onopen = this.open
					this.socket.onerror = this.error
					this.socket.onmessage = this.getMessage
					this.socket.onclose = this.websocketclose
				}
			},
			scheduleReconnect(url, delay) {
				if (this.isDestroyed) return
				clearTimeout(this.reconnectTimer)
				this.reconnectTimer = setTimeout(() => {
					this.initWebSocket(url)
				}, delay)
			},
			open() {
				var self = this
				// 连接成功后清零，否则长时间挂机的偶发断连会累加到阈值触发登出
				self.timeEnd = 0
				self.retryNotified = false
				self.$emit('socketState', true)
				self.timeoutObj = window.setInterval(function() {
					if (self.socket && self.socket.readyState === 1) {
						self.socket.send('heartCheck')
					}
				}, self.timeout)
			},
			error() {
				// 失败后的重连统一由 onclose 处理，这里不直接登出
			},
			getMessage(event) {
				let that = this
				if (event.data !== '连接成功') {
					let socketData = JSON.parse(event.data)
					if (socketData.socketType !== '5') {
						that.$emit('backSockertData', socketData)
					}
					// 单点登陆
					if (socketData.socketType === '15') {
						const myCrc = getItem('kakcrc')
						const macs = socketData.macs
						// 后端没下发任何mac内容时不构成顶号证据，不能据此踢人
						const noEvidence = macs === undefined || macs === null || macs === '' ||
							(Array.isArray(macs) && macs.length === 0)
						if (noEvidence) {
							traceAuth('信令socketType15：后端未下发mac列表（macs=' + JSON.stringify(macs) +
								' 本机crc=' + myCrc + '），已忽略')
						} else {
							// macs 可能是数组，也可能是拼接字符串，两种都按包含关系比对
							const listed = Array.isArray(macs) ?
								macs.indexOf(myCrc) !== -1 :
								String(macs).indexOf(myCrc) !== -1
							if (!myCrc) {
								traceAuth('信令socketType15：本机crc缺失，无法比对（macs=' +
									JSON.stringify(macs).slice(0, 200) + '）')
							}
							if (!listed) {
								traceAuth('信令socketType15：本机crc不在mac列表（macs=' + JSON.stringify(macs).slice(0, 200) +
									' 本机=' + myCrc + '）')
								that.$message({
									message: '您的账号已在另一处登陆',
									type: 'warning',
									duration: '2000'
								});
								setTimeout(() => {
									removeToken()
									removeItem('differtime')
									that.$router.push({
										name: 'login'
									})
								}, 2000)
							}
						}
					}
				} else {}
			},
			websocketclose() {
				let self = this
				window.clearInterval(self.timeoutObj)
				self.socket = null
				if (!self.isDestroyed) self.$emit('socketState', false)
				// 原实现是同步立即重连，网络瞬断时几次失败会在毫秒内跑完并触发登出
				self.scheduleReconnect(self.socketUrl, 5000)
			}
		},
		destroyed() {
			let that = this
			that.isDestroyed = true
			window.clearInterval(that.timeoutObj)
			clearTimeout(that.reconnectTimer)
			if (that.socket) {
				// 先摘回调再 close：否则 onclose 会在已销毁的实例上再跑一遍重连与踢人逻辑
				that.socket.onopen = null
				that.socket.onerror = null
				that.socket.onmessage = null
				that.socket.onclose = null
				that.socket.close()
			}
			that.socket = null
		}
	}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/RobotSocket.vue